var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2143 3.48071H2.77701C1.24487 3.48071 0 4.72681 0 6.25649V39.2049C0 40.7346 1.24487 41.9807 2.77701 41.9807H36.2143C37.7464 41.9807 39 40.7346 39 39.2049V6.25649C39 4.72681 37.7464 3.48071 36.2143 3.48071ZM11.7871 36.4807H6.0067V18.1073H11.7958V36.4807H11.7871ZM8.89688 15.5979C7.04263 15.5979 5.54531 14.1112 5.54531 12.2893C5.54531 10.4674 7.04263 8.98071 8.89688 8.98071C10.7424 8.98071 12.2484 10.4674 12.2484 12.2893C12.2484 14.1198 10.7511 15.5979 8.89688 15.5979ZM33.4547 36.4807H27.6743V27.5432C27.6743 25.412 27.6308 22.6706 24.671 22.6706C21.6589 22.6706 21.1975 24.9909 21.1975 27.3885V36.4807H15.4172V18.1073H20.9625V20.6166H21.0408C21.8156 19.1729 23.7047 17.6518 26.5165 17.6518C32.3665 17.6518 33.4547 21.4588 33.4547 26.4088V36.4807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.17a3e347b397ff054ec02a2794dc0981.svg";
export { ForwardRef as ReactComponent };